import {
  Box,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  Button,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
} from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled, useTheme } from "@mui/material/styles";
import { apiUser } from "../../Apis/configs/axiosConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { SpinnerCircular } from "spinners-react";
import Draggable from "react-draggable";
import "react-resizable/css/styles.css";
import Modal from "@mui/material/Modal";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import "react-resizable/css/styles.css";
import "./styles.css";
import Swal from "sweetalert2";
import pointIcon from "./img/dot.png";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
  useMap,
  Polygon,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { blue, blueGrey, green, grey, red } from "@mui/material/colors";
import PolygonMaker from "../../Components/DrawCanvas";
import sitemasterIcon from "./img/myController.png";
import imageCompression from "browser-image-compression";

import {
  ArrowBack,
  Delete,
  Edit,
  EditOff,
  FormatShapes,
  HourglassBottom,
  PlayArrow,
  Save,
} from "@mui/icons-material";
import "reactjs-popup/dist/index.css";
import ReactPopup from "reactjs-popup";
import Popper from "@mui/material/Popper";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import useMediaQuery from "@mui/material/useMediaQuery";

const styleRadioButton = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: "white",
  borderRadius: 6,
  boxShadow: "0 4px 8px rgba(5, 11, 0, 0.4)",
  padding: 1,
  color: "black",
  fontSize: 16,
  textAlign: "center",
  maxHeight: "50%",
  overflow: "auto",
};

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const labelStyle = {
  fontSize: "22px",
  fontWeight: "bold",
  marginBottom: "10px",
  color: "#032C65",
};

const MapsWrapper = ({ selectedOption, onImgChange }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const mapCenterRef = useRef({ lat: 0, lng: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const [address, setAddress] = useState(null);
  const [mapCenter, setMapCenter] = useState(null);
  const [loadingMap, setLoadingMap] = useState(true);
  const [zonesF, setZonesF] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedZoneMarker, setSelectedZoneMarker] = useState(null);
  const [imageMarkers, setImageMarkers] = useState([]);
  const [selectedMarkerId, setSelectedMarkerId] = useState(null);
  const [selectedOptionSite, setSelectedOptionSite] = useState(null);
  const [newSiteplan, setnewSiteplan] = useState(false);
  const [opt, setopt] = useState(0);
  const [colors, setColors] = useState([
    "#42a5f5",
    "#e57373",
    "#ec407a",
    "#9c27b0",
    "#c62828",
    "#4a148c",
    "#009688",
    "#a5d6a7",
    "#cddc39",
    "#64dd17",
    "#fff59d",
    "#fdd835",
    "#ff9800",
    "#ff7043",
    "#6d4c41",
  ]);
  const [tool, setTool] = useState("Line");
  const [allZones, setAllZones] = useState([]);
  const [allPrograms, setAllPrograms] = useState({});
  const [zone, setZone] = useState(null);
  const [mapData, setmapData] = useState(null);
  const [img, setImg] = useState(mapData ?? "");
  const [clicks, setClicks] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [zoneMapMarker, setzoneMapMarker] = useState(null);
  const [mapviewData, setmapviewData] = useState(null);
  const [shapes, setShapes] = useState([]);
  const [points, setPoints] = useState([]);
  const [selManualZone, setSelManualZone] = useState(null);
  const [manualRunOpen, setManualRunOpen] = useState(false);
  const [pushingManual, setPushingManual] = useState(false);
  const [runtimeHours, setRuntimeHours] = useState(0);
  const [runtimeMins, setRuntimeMins] = useState(0);
  const [polygons, setPolygons] = useState([]);
  const [dataShape, setdataShape] = useState(null);
  const [adviceMap, setadviceMap] = useState(0); // State = 1 -> cant use map view, cause dont have an address.
  const [drawing, setdrawing] = useState(false);
  const [makeShapes, setmakeShapes] = useState(false);
  const [openZoneInfo, setopenZoneInfo] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [addZoneBoundarie, setaddZoneBoundarie] = useState(false);
  const [markerinfo, setmarkerinfo] = useState(null);
  const [actualShape, setactualShape] = useState(null);
  const [addControllerPin, setaddControllerPin] = useState(false);
  const [ControllerPinSitePlan, setControllerPinSitePlan] = useState([]);
  const [removedBoundarie, setremovedBoundarie] = useState(false);
  const [hasAddressAdviceShown, setAddressAdviceShown] = useState(false);
  const [imageInfo, setImageInfo] = useState(null); // Store scaled image dimensions
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const closeModal = () => {
    setSelectedOptionSite(null);
    setmarkerinfo(null);
    setopenZoneInfo(false);
    setSelectedMarkerId(null);
  };

  function writeAnnouncementCookie() {
    const cookieId = `${location.state.id}_location`;

    const d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cookieId + "=true;" + expires + ";path=/";
  }

  function getAnnouncementCookieValue() {
    let name = `${location.state.id}_location=`;
    let decodedCookie = decodeURIComponent(document.cookie);

    let ca = decodedCookie.split(";");

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];

      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }

      if (c.indexOf(name) === 0) {
        return true;
      }
    }

    return false;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingMap(true);
        const currentStatusResponse = await apiUser.get(
          `/controllers/${location.state.id}`
        );

        setAddress(currentStatusResponse.data.data.address);
        setAllZones(currentStatusResponse.data.data.zones);
        setAllPrograms(currentStatusResponse.data.data.programs);
        const latitude = Number(
          currentStatusResponse.data.data.address
            ? currentStatusResponse.data.data.address.latitude
            : null
        );
        const longitude = Number(
          currentStatusResponse.data.data.address
            ? currentStatusResponse.data.data.address.longitude
            : null
        );
        if (
          !isNaN(latitude) &&
          !isNaN(longitude) &&
          latitude !== 0 &&
          longitude !== 0
        ) {
          setadviceMap(3);
          setMapCenter({
            lat: latitude,
            lng: longitude,
            text: "Controller Address",
          });
          mapCenterRef.current = { lat: latitude, lng: longitude };
        } else {
          showAddressAdvice();
          return;
        }

        const zone_f = currentStatusResponse.data.data.zones;
        if (zone_f) {
          const zones_to_filter = zone_f.filter(
            (item) => item.decoder !== "000000"
          );
          setZonesF(zones_to_filter);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoadingMap(false);
      }
    };

    const fetchMapData = async () => {
      try {
        const request = await apiUser.get(
          `/controllers/${location.state.id}/map_data`
        );

        setmapData(request.data.data.map_data.img_based);
        setmapviewData(request.data.data.map_data.geo_based);

        if (request.data.data.map_data.geo_based !== null) {
          setMarkers(request.data.data.map_data.geo_based.decoder_pins);
        }
        let imgData = request.data.data.map_data.img_based;
        if (imgData !== null) {
          imgData = request.data.data.map_data.img_based.image_data;
          setImg(`${imgData}`);
          onImgChange(`${imgData}`);
        }
      } catch (error) {
        console.error(error, "ERR");
      }
    };

    fetchData();
    fetchMapData();
  }, [location.state.id]);

  // Helper: Detect if saved coordinates are percentages (0-1) or absolute (pixels)
  const isPercentage = (value) => {
    // If value is between 0 and 1 (or very close), it's likely a percentage
    return value >= 0 && value <= 1.1;
  };

  // Helper: Convert absolute coordinates to percentage (0-1) relative to scaled image
  // Since we maintain aspect ratio, percentages are stable across screen sizes
  const absoluteToPercentage = (x, y, imageInfo) => {
    if (!imageInfo || !imageInfo.scaledWidth || !imageInfo.scaledHeight) {
      return { x: 0, y: 0 };
    }
    
    // Calculate position relative to scaled image (subtract image offset for centering)
    const relativeX = x - imageInfo.imageX;
    const relativeY = y - imageInfo.imageY;
    
    // Convert to percentage (0-1) based on scaled image size
    // This percentage is the same for original size since aspect ratio is maintained
    const percentX = relativeX / imageInfo.scaledWidth;
    const percentY = relativeY / imageInfo.scaledHeight;
    
    // Clamp to valid range [0, 1]
    return { 
      x: Math.max(0, Math.min(1, percentX)), 
      y: Math.max(0, Math.min(1, percentY)) 
    };
  };

  // Helper: Convert percentage (0-1) to absolute coordinates based on current scaled image
  const percentageToAbsolute = (percentX, percentY, imageInfo) => {
    if (!imageInfo || !imageInfo.scaledWidth || !imageInfo.scaledHeight) {
      return { x: percentX, y: percentY };
    }
    
    // Clamp percentages to valid range [0, 1]
    const clampedX = Math.max(0, Math.min(1, percentX));
    const clampedY = Math.max(0, Math.min(1, percentY));
    
    // Convert percentage to position on scaled image
    const scaledX = clampedX * imageInfo.scaledWidth;
    const scaledY = clampedY * imageInfo.scaledHeight;
    
    // Add image offset (for centering) to get absolute position in container
    const absoluteX = scaledX + imageInfo.imageX;
    const absoluteY = scaledY + imageInfo.imageY;
    
    return { x: absoluteX, y: absoluteY };
  };

  // Track if data has been loaded from mapData to prevent duplicates on resize
  const dataLoadedFromMapRef = useRef(false);
  // Store original mapData before processing (to preserve percentage coordinates for updates)
  const originalMapDataRef = useRef(null);
  
  // Load map data when mapData/mapviewData changes (only process once)
  useEffect(() => {
    if (mapData || mapviewData) {
      // Store original data before processing (deep copy)
      if (mapData) {
        originalMapDataRef.current = JSON.parse(JSON.stringify(mapData));
      }
      showMapData();
      dataLoadedFromMapRef.current = true;
    }
    // Reset flag when location changes (new controller loaded)
    return () => {
      dataLoadedFromMapRef.current = false;
      originalMapDataRef.current = null;
    };
  }, [mapData, mapviewData]);
  
  // Update positions of existing pins when image info changes (window resize)
  // This only updates positions without recreating pins
  useEffect(() => {
    if (imageInfo && dataLoadedFromMapRef.current && mapData) {
      // Only update positions, don't recreate from mapData
      updateExistingPinPositions();
    }
  }, [imageInfo?.scaledWidth, imageInfo?.scaledHeight, imageInfo?.imageX, imageInfo?.imageY]);
  
  // Function to update only positions of existing pins (not recreate them)
  // This is called when window resizes, so pins need to reposition
  const updateExistingPinPositions = () => {
    // Use originalMapDataRef which has the saved percentage coordinates, not the processed mapData
    const originalData = originalMapDataRef.current;
    if (!originalData || !imageInfo) return;
    
    // Update decoder pins: use saved percentages from original data to recalculate positions
    if (originalData.decoder_pins) {
      setImageMarkers(prevMarkers => {
        // Only update if we have existing markers
        if (prevMarkers.length === 0) return prevMarkers;
        
        return prevMarkers.map((existingMarker) => {
          // Find corresponding saved data by zone_ref
          const savedData = originalData.decoder_pins.find(p => p.zone_ref === existingMarker.zone_ref);
          if (savedData) {
            const savedX = parseFloat(savedData.position.lat);
            const savedY = parseFloat(savedData.position.lng);
            
            // Only update if coordinates are percentages (new format)
            if (isPercentage(savedX) && isPercentage(savedY)) {
              const newPosition = percentageToAbsolute(savedX, savedY, imageInfo);
              return {
                ...existingMarker,
                position: newPosition
              };
            }
          }
          // Keep existing position if can't update (old format or not found)
          return existingMarker;
        });
      });
    }
    
    // Update controller pin position
    if (originalData.controller_pin) {
      setControllerPinSitePlan(prevPins => {
        if (prevPins.length === 0) return prevPins;
        
        const savedX = Number(originalData.controller_pin.lat);
        const savedY = Number(originalData.controller_pin.lng);
        
        if (isPercentage(savedX) && isPercentage(savedY)) {
          const newPosition = percentageToAbsolute(savedX, savedY, imageInfo);
          return [{
            ...prevPins[0],
            position: newPosition
          }];
        }
        return prevPins;
      });
    }
    
    // Update polygon positions using original data (with percentage coordinates)
    if (originalData.zone_boundaries) {
      setPolygons(prevPolygons => {
        // Only update if we have existing polygons
        if (prevPolygons.length === 0) return prevPolygons;
        
        return prevPolygons.map((existingPolygon) => {
          // Find corresponding saved polygon by zone_ref from original data
          const savedPolygon = originalData.zone_boundaries.find(p => p.zone_ref === existingPolygon.zone_ref);
          
          if (savedPolygon && savedPolygon.shape_points && Array.isArray(savedPolygon.shape_points)) {
            const updatedShapePoints = savedPolygon.shape_points.map((point) => {
              let savedX, savedY;
              
              // Handle both formats: {lat, lng} or [x, y]
              // Original data should be in {lat, lng} format (percentages saved as lat/lng)
              if (typeof point === 'object' && point !== null && !Array.isArray(point)) {
                // Format: {lat, lng} - this is the format from saved data
                savedX = parseFloat(point.lat);
                savedY = parseFloat(point.lng);
              } else if (Array.isArray(point) && point.length >= 2) {
                // Format: [x, y] - might be already processed, but shouldn't be in original data
                // But handle it just in case
                savedX = parseFloat(point[0]);
                savedY = parseFloat(point[1]);
              }
              
              // Convert if coordinates are percentages (new format)
              if (savedX !== undefined && savedY !== undefined) {
                if (isPercentage(savedX) && isPercentage(savedY)) {
                  const abs = percentageToAbsolute(savedX, savedY, imageInfo);
                  return [abs.x, abs.y];
                }
                // Old format: absolute coordinates
                return [savedX, savedY];
              }
              
              // Keep as-is if we can't parse
              return Array.isArray(point) ? point : [0, 0];
            });
            
            return {
              ...existingPolygon,
              shape_points: updatedShapePoints
            };
          }
          // Keep existing polygon if not found in saved data
          return existingPolygon;
        });
      });
    }
  };

  const showMapData = () => {
    // site plan data

    if (
      mapData !== null &&
      mapData.decoder_pins !== null &&
      mapData.zone_boundaries !== null
    ) {
      // Process decoder pins: supports both old absolute and new percentage coordinates
      const updatedMapDataDecoder = mapData.decoder_pins.map((item) => {
        const savedX = parseFloat(item.position.lat);
        const savedY = parseFloat(item.position.lng);
        
        let newPosition;
        if (imageInfo) {
          // Check if coordinates are percentages (0-1) or absolute (old format)
          if (isPercentage(savedX) && isPercentage(savedY)) {
            // New format: percentages, convert to absolute
            newPosition = percentageToAbsolute(savedX, savedY, imageInfo);
          } else {
            // Old format: absolute coordinates (legacy data)
            // These were saved as absolute pixels, likely relative to original image size
            // For legacy data, try to preserve position by assuming they were relative to original size
            // This is not perfect but better than losing the pins completely
            console.warn('Loading legacy absolute coordinates. Consider re-saving to use percentage format.');
            newPosition = { x: savedX, y: savedY };
          }
        } else {
          // Fallback if imageInfo not ready
          newPosition = { x: savedX, y: savedY };
        }

        return {
          ...item,
          id: Math.floor(Math.random() * 1000) + 1,
          position: newPosition,
        };
      });

      if (mapData.controller_pin) {
        const savedX = Number(mapData.controller_pin.lat);
        const savedY = Number(mapData.controller_pin.lng);
        
        let newPosition;
        if (imageInfo) {
          if (isPercentage(savedX) && isPercentage(savedY)) {
            // New format: percentages
            newPosition = percentageToAbsolute(savedX, savedY, imageInfo);
          } else {
            // Old format: absolute coordinates
            newPosition = { x: savedX, y: savedY };
          }
        } else {
          newPosition = { x: savedX, y: savedY };
        }
        
        mapData.controller_pin = {
          ...mapData.controller_pin,
          position: newPosition,
          id: Math.floor(Math.random() * 1000) + 1,
        };
        setControllerPinSitePlan([mapData.controller_pin]);
      } else {
      }

      // Process zone boundaries: convert from percentages to absolute coordinates
      mapData.zone_boundaries.forEach((item, index) => {
        if (item.shape_points && Array.isArray(item.shape_points)) {
          item.shape_points = item.shape_points.map((point) => {
            let savedX, savedY;
            
            // Handle both formats: {lat, lng} or [x, y]
            if (typeof point === 'object' && point !== null && !Array.isArray(point)) {
              // Format: {lat, lng}
              savedX = parseFloat(point.lat);
              savedY = parseFloat(point.lng);
            } else if (Array.isArray(point) && point.length >= 2) {
              // Format: [x, y]
              savedX = parseFloat(point[0]);
              savedY = parseFloat(point[1]);
            }
            
            if (savedX !== undefined && savedY !== undefined) {
              if (imageInfo && isPercentage(savedX) && isPercentage(savedY)) {
                // New format: percentages, convert to absolute
                const abs = percentageToAbsolute(savedX, savedY, imageInfo);
                return [abs.x, abs.y];
              } else {
                // Old format: absolute coordinates (or fallback)
                return [savedX, savedY];
              }
            }
            
            // Fallback: keep as array if already in that format
            return Array.isArray(point) ? point : [0, 0];
          });
        }
        const zoneprops = zonesF.filter(
          (zone) => zone.decoder === item.zone_ref
        );
        mapData.zone_boundaries[index] = {
          ...item,
          zoneprops: zoneprops,
        };
      });
      setPolygons(mapData.zone_boundaries);
      setImageMarkers(updatedMapDataDecoder);
    } else {
    }
    // map view data
    if (
      mapviewData !== null &&
      mapviewData.decoder_pins !== null &&
      mapviewData.zone_boundaries !== null
    ) {
      // console.log(mapviewData);

      // proccesing lat and lng points of decoder pins in map view data

      const updatedMapDataDecoder = mapviewData.decoder_pins.map((item) => {
        const newPosition = {
          lat: parseFloat(item.position.lat),
          lng: parseFloat(item.position.lng),
        };

        return {
          ...item,
          id: Math.floor(Math.random() * 1000) + 1,
          position: newPosition,
        };
      });

      // proccesing lat and lng points of zone boundaries in map view data
      mapviewData.zone_boundaries.forEach((item) => {
        if (Array.isArray(item.shape_points)) {
          item.shape_points = item.shape_points
            .map((point) => {
              let lat;
              let lng;

              if (point && typeof point === "object" && !Array.isArray(point)) {
                lat = parseFloat(point.lat);
                lng = parseFloat(point.lng);
              } else if (Array.isArray(point) && point.length >= 2) {
                lat = parseFloat(point[0]);
                lng = parseFloat(point[1]);
              }

              if (Number.isFinite(lat) && Number.isFinite(lng)) {
                return [lat, lng];
              }
              return null;
            })
            .filter((coords) => Array.isArray(coords));
        }
      });
      setShapes(mapviewData.zone_boundaries);
      setMarkers(updatedMapDataDecoder);
      // console.log(mapviewData.decoder_pins);
    }
  };

  //------------------> OPEN STREET FUNCTIONS <-----------------//
  const onClick = (e) => {
    // Check if click was on a marker (not on the map itself)
    // If click was on the map (not on a marker) and we're not adding a new pin, deselect current marker
    if (!zoneMapMarker && opt !== 2) {
      // Click was on the map, not on a marker, deselect if one is selected
      if (selectedMarkerId !== null) {
        setSelectedMarkerId(null);
        setmarkerinfo(null);
        setopenZoneInfo(false);
        setAnchorEl(null);
      }
    }
    
    if (zoneMapMarker) {
      const mark = {
        position: { lat: e.latlng.lat, lng: e.latlng.lng },
        zone_ref: zoneMapMarker.zone_ref || "",
        zone_name: zoneMapMarker.zone_name || "",
      };
      setClicks([...clicks, e.latLng]);
      // filter out existing instances of a pin pointing to the same zone_ref
      setMarkers([
        ...markers.filter((item) => item.zone_ref !== mark.zone_ref),
        mark,
      ]);
      setzoneMapMarker(null);
      setSelectedOptionSite(null);
      setmakeShapes(true);
    } else if (opt === 2) {
      // Adding zone boundaries
      const newPoint = [e.latlng.lat, e.latlng.lng];
      setPoints([...points, newPoint]);
    }
  };

  const MapEventsHandler = () => {
    useMapEvents({
      click: (e) => onClick(e),
    });
  };
  const MarkerPopup = ({ zoneRef, zoneMarker }) => {
    // const zoneData = allZones.find((item) => item.decoder === zoneRef);
    const zoneIndex = allZones.findIndex((item) => item.decoder === zoneRef);

    const zoneData = zoneIndex >= 0 ? allZones[zoneIndex] : {};

    const programsAffected = Object.keys(allPrograms).filter((progLetter) => {
      const zoneRt = allPrograms[progLetter].run_times[zoneIndex] || {};

      return zoneRt.hour > 0 || zoneRt.minutes > 0 || zoneRt.seconds > 0;
    });

    const renderZoneInfoPanel = (onCloseHandler = closeModal) => {
      const isMapView = selectedOption === 1;
      const isDecoderTarget = zoneMarker;
      const removalSubjectKey = isDecoderTarget ? "Decoder pin" : "Zone boundary";
      const removalActionKey = isDecoderTarget
        ? "Remove Decoder pin"
        : "Remove zone boundaries";
      const canEditZone =
        !isMapView && dataShape !== null && !isDecoderTarget;

      const handleRemoval = () => {
        if (isMapView) {
          removeFromMap(zoneRef, isDecoderTarget);
        } else {
          setremovedBoundarie(true);
          removeFromSitePlan(zoneRef);
        }
      };

      const handleEditClick = () => {
        onCloseHandler();
        setopt(1);
        showBoundaries(5);
      };

      return (
        <Paper
        elevation={0}
        sx={{
          borderRadius: 2,
          padding: { xs: 2, sm: 2.5 },
          background: "#ffffff",
          border: `1px solid ${grey[200]}`,
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
          minWidth: { xs: "280px", sm: "380px" },
          maxWidth: { xs: "90vw", sm: "480px" },
          width: "100%",
        }}
      >
        <List sx={{ padding: 0 }}>
          {/* Header with close button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 2,
              paddingBottom: 1.5,
              borderBottom: `1px solid ${grey[200]}`,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "#032C65",
                fontSize: { xs: "1rem", sm: "1.15rem" },
              }}
            >
              {t("Zone Information")}
            </Typography>
            <Stack direction="row" spacing={0.5} alignItems="center">
              {canEditZone && (
                <IconButton
                  onClick={handleEditClick}
                  size="small"
                  sx={{
                    color: grey[600],
                    padding: 0.5,
                    "&:hover": {
                      backgroundColor: grey[100],
                      color: "#032C65",
                    },
                  }}
                >
                  <Edit sx={{ fontSize: { xs: "1rem", sm: "1.15rem" } }} />
                </IconButton>
              )}
              <IconButton
                onClick={onCloseHandler}
                size="small"
                sx={{
                  color: grey[600],
                  padding: 0.5,
                  "&:hover": {
                    backgroundColor: grey[100],
                    color: "#032C65",
                  },
                }}
              >
                <CloseIcon sx={{ fontSize: { xs: "1.1rem", sm: "1.25rem" } }} />
              </IconButton>
            </Stack>
          </Box>
          {/* Zone information */}
          <Box
            sx={{
              backgroundColor: grey[50],
              borderRadius: 1.5,
              padding: { xs: 1.5, sm: 2 },
              marginBottom: 2,
              border: `1px solid ${grey[200]}`,
            }}
          >
            <ListItem sx={{ padding: 0 }}>
              <ListItemAvatar>
                <Avatar
                  sx={{
                    backgroundColor: "#032C65",
                    width: { xs: 40, sm: 44 },
                    height: { xs: 40, sm: 44 },
                  }}
                >
                  <FormatShapes sx={{ fontSize: { xs: "1.2rem", sm: "1.4rem" } }} />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      color: "#032C65",
                      fontSize: { xs: "1rem", sm: "1.1rem" },
                    }}
                  >
                    {zoneData.zone_name
                      ? zoneData.zone_name
                      : t(`Zone`) + ` ${zoneIndex + 1}`}
                  </Typography>
                }
                secondary={
                  <Typography
                    sx={{
                      color: grey[600],
                      fontSize: { xs: "0.8rem", sm: "0.85rem" },
                      marginTop: 0.25,
                    }}
                  >
                    {zoneData.decoder || t(`Decoder not assigned`)}
                  </Typography>
                }
              />
            </ListItem>
          </Box>

          <Box sx={{ marginBottom: 2 }}>
            <Button
              fullWidth
              variant="contained"
              startIcon={<PlayArrow />}
              onClick={() => {
                setManualRunOpen(true);
                setSelManualZone({
                  ...zoneData,
                  number: zoneIndex + 1,
                });
              }}
              sx={{
                backgroundColor: green[600],
                color: "white",
                padding: { xs: 1, sm: 1.25 },
                fontSize: { xs: "0.9rem", sm: "0.95rem" },
                fontWeight: 600,
                borderRadius: 1.5,
                textTransform: "none",
                boxShadow: "0 2px 8px rgba(46, 125, 50, 0.25)",
                "&:hover": {
                  backgroundColor: green[700],
                  boxShadow: "0 4px 12px rgba(46, 125, 50, 0.35)",
                },
                transition: "all 0.2s ease",
              }}
            >
              {t(`Run zone`)}
            </Button>
            <Typography
              sx={{
                textAlign: "center",
                marginTop: 0.75,
                color: grey[600],
                fontSize: { xs: "0.7rem", sm: "0.75rem" },
                fontStyle: "italic",
              }}
            >
              {t("You can manually run this zone")}
            </Typography>
          </Box>
          
          {programsAffected.length > 0 && (
            <Box sx={{ marginBottom: 2 }}>
              <Typography
                sx={{
                  fontWeight: 600,
                  color: "#032C65",
                  marginBottom: 1,
                  fontSize: { xs: "0.85rem", sm: "0.9rem" },
                }}
              >
                {t(`Programs affected`)}:
              </Typography>
              <Box
                sx={{
                  borderRadius: 1.5,
                  border: `1px solid ${grey[200]}`,
                  backgroundColor: grey[50],
                  maxHeight: { xs: 150, sm: 200 },
                  overflowY: "auto",
                }}
              >
                {programsAffected.map((progLetter, index) => {
                  const zoneRt =
                    allPrograms[progLetter].run_times[zoneIndex] || {};

                  const hrs = zoneRt.hour.toString().padStart(2, "0");
                  const mins = zoneRt.minutes.toString().padStart(2, "0");
                  const secs = zoneRt.seconds.toString().padStart(2, "0");

                  return (
                    <ListItem
                      key={`p-${progLetter}-rt-${zoneIndex}`}
                      sx={{
                        backgroundColor:
                          index % 2 === 0 ? "transparent" : grey[100],
                        borderRadius: 1,
                        margin: "2px 6px",
                        padding: { xs: "6px 8px", sm: "8px 12px" },
                        "&:hover": {
                          backgroundColor: grey[200],
                          transition: "background-color 0.2s ease",
                        },
                      }}
                    >
                      <ListItemAvatar>
                        <Avatar
                          sx={{
                            backgroundColor: "#032C65",
                            width: { xs: 28, sm: 32 },
                            height: { xs: 28, sm: 32 },
                          }}
                        >
                          <HourglassBottom sx={{ fontSize: { xs: 14, sm: 16 } }} />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Typography
                            sx={{
                              fontWeight: 600,
                              color: "#032C65",
                              fontSize: { xs: "0.8rem", sm: "0.85rem" },
                            }}
                          >
                            {t(`Program`)} {progLetter.toUpperCase()}
                          </Typography>
                        }
                        secondary={
                          <Typography
                            sx={{
                              color: grey[700],
                              fontSize: { xs: "0.75rem", sm: "0.8rem" },
                              fontFamily: "monospace",
                            }}
                          >
                            {`${hrs}:${mins}:${secs}`}
                          </Typography>
                        }
                      />
                    </ListItem>
                  );
                })}
              </Box>
            </Box>
          )}

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1}
            sx={{ marginTop: 1.5 }}
          >
            <Button
              variant="outlined"
              startIcon={<Delete />}
              fullWidth
              size="small"
              onClick={() => {
                Swal.fire({
                  title: t(removalActionKey),
                  text: `${t("Are you sure to remove")} ${zoneData.zone_name} ${t(removalSubjectKey)}?`,
                  icon: "question",
                  showConfirmButton: true,
                  confirmButtonColor: "#BF0021",
                  confirmButtonText: t(removalActionKey),
                  showDenyButton: true,
                  denyButtonText: t("Cancel"),
                  denyButtonColor: "#032C65",
                }).then((data) => {
                  if (data.isConfirmed) {
                    handleRemoval();
                    onCloseHandler();
                  }
                });
              }}
              sx={{
                color: "#BF0021",
                borderColor: red[300],
                fontSize: { xs: "0.75rem", sm: "0.8rem" },
                fontWeight: 600,
                padding: { xs: "6px 12px", sm: "8px 16px" },
                minHeight: { xs: "32px", sm: "36px" },
                borderRadius: 1.5,
                textTransform: "none",
                "&:hover": {
                  borderColor: red[500],
                  backgroundColor: red[50],
                },
                transition: "all 0.2s ease",
                "& .MuiButton-startIcon": {
                  marginRight: { xs: 0.5, sm: 0.75 },
                  "& > *:nth-of-type(1)": {
                    fontSize: { xs: "1rem", sm: "1.1rem" },
                  },
                },
              }}
            >
              {t(removalActionKey)}
            </Button>
            {canEditZone && (
              <Button
                variant="contained"
                startIcon={<Edit />}
                fullWidth
                size="small"
                onClick={handleEditClick}
                sx={{
                  backgroundColor: "#032C65",
                  color: "white",
                  fontSize: { xs: "0.75rem", sm: "0.8rem" },
                  fontWeight: 600,
                  padding: { xs: "6px 12px", sm: "8px 16px" },
                  minHeight: { xs: "32px", sm: "36px" },
                  borderRadius: 1.5,
                  textTransform: "none",
                  boxShadow: "0 2px 8px rgba(3, 44, 101, 0.25)",
                  "&:hover": {
                    backgroundColor: "#021d4a",
                    boxShadow: "0 4px 12px rgba(3, 44, 101, 0.35)",
                  },
                  transition: "all 0.2s ease",
                  "& .MuiButton-startIcon": {
                    marginRight: { xs: 0.5, sm: 0.75 },
                    "& > *:nth-of-type(1)": {
                      fontSize: { xs: "1rem", sm: "1.1rem" },
                    },
                  },
                }}
              >
                {t(`Edit`)}
              </Button>
            )}
          </Stack>
        </List>
      </Paper>
      );
    };
    if (selectedOption === 1) {
      // Para map view, usar Popup de react-leaflet directamente
      // Crear un componente que pueda usar useMap dentro del Popup
      const PopupContent = () => {
        const map = useMap();
        
        const handleClose = () => {
          map.closePopup();
          closeModal();
        };
        
        return (
          <div style={{ margin: 0, padding: 0 }}>
            {renderZoneInfoPanel(handleClose)}
          </div>
        );
      };
      
      return (
        <Popup
          className="custom-leaflet-popup"
          maxWidth={480}
          minWidth={280}
        >
          <PopupContent />
        </Popup>
      );
    }
    
    return (
      <>
        {selectedOption === 1 ? null : (
          <Grid item container xs={12} justifyContent="center">
            {isSmallScreen ? (
              <Popper
                anchorEl={anchorEl}
                open={openZoneInfo}
                placement="auto"
                modifiers={[
                  { name: "flip", enabled: true },
                  {
                    name: "preventOverflow",
                    enabled: true,
                    options: { padding: 16 },
                  },
                ]}
                sx={{
                  zIndex: 1300,
                  maxWidth: { xs: "calc(100vw - 32px)", sm: 480 },
                  minWidth: { xs: "280px", sm: "380px" },
                  width: { xs: "calc(100vw - 32px)", sm: "auto" },
                }}
              >
                {renderZoneInfoPanel()}
              </Popper>
            ) : (
              openZoneInfo && (
                <Box
                  sx={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1300,
                    minWidth: { xs: "280px", sm: "380px" },
                    maxWidth: { xs: "90vw", sm: "480px" },
                    width: { xs: "90vw", sm: "auto" },
                  }}
                >
                  {renderZoneInfoPanel()}
                </Box>
              )
            )}
          </Grid>
        )}
      </>
    );
  };
  const markerDrag = (id, e, ui) => {
    // console.log(e.target._latlng.lat);
    const updatedMarkers = markers.map((marker) =>
      marker.id === id
        ? {
            ...marker,
            position: {
              lat: e.target._latlng.lat,
              lng: e.target._latlng.lng,
            },
          }
        : marker
    );

    // console.log(updatedMarkers);

    setMarkers(updatedMarkers);
  };


  const saveShape = (color, zone) => {
    const newShape = {
      id: shapes.length + 1,
      position: { x: 0, y: 0 },
      color: color || "black",
      shape_points: points,
      zone_ref: zone,
    };

    setShapes([
      ...shapes.filter((item) => item.zone_ref !== newShape.zone_ref),
      newShape,
    ]);
    setPoints([]);
    setopt(0);
  };
  const removeFromMap = (zoneRef, isMarker) => {
    if (isMarker) {
      const updatedMarker = markers.filter((item) => item.zone_ref !== zoneRef);
      setMarkers([...updatedMarker]);
    } else {
      const updatedShapes = shapes.filter((item) => item.zone_ref !== zoneRef);

      setShapes([...updatedShapes]);
    }
  };

  const removeFromSitePlan = (zoneRef) => {
    setremovedBoundarie(true);

    if (markerinfo !== null) {
      const updatedImageMarker = imageMarkers.filter(
        (item) => item.zone_ref !== zoneRef
      );
      setImageMarkers([...updatedImageMarker]);
    }
    if (dataShape !== null) {
      const updtpolygons = polygons.filter((item) => item.zone_ref !== zoneRef);

      setPolygons(updtpolygons);
    }
  };

  //--------------------------------------------------------------//

  //------------------> HANDLE IMGS FUNCTIONS <-----------------//
  const handleIMG = async (e) => {
    setPolygons([]);
    setImageMarkers([]);
    setControllerPinSitePlan([]);
    setImg("");
    setnewSiteplan(true);

    const MAX_IMAGE_SIZE_AFTER_COMPRESSION = 1024 * 1024; // 1MB after compression
    const MAX_IMAGE_SIZE_BEFORE_COMPRESSION = 10 * 1024 * 1024; // 10MB before compression (for mobile)

    const options = {
      maxSizeMB: 0.3,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    const file = e.target.files[0];

    try {
      // Allow larger images before compression (especially for mobile)
      if (file.size > MAX_IMAGE_SIZE_BEFORE_COMPRESSION) {
        Swal.fire({
          title: t("errors.image_too_big"),
          text: t("errors.image_too_big_explanation"),
          icon: "error",
          confirmButtonText: t("Confirm"),
        });
        return;
      }

      // Intentar comprimir la imagen primero
      const compressedFile = await imageCompression(file, options);

      // Verify size after compression
      if (compressedFile.size > MAX_IMAGE_SIZE_AFTER_COMPRESSION) {
        Swal.fire({
          title: t("errors.image_too_big"),
          text: t("errors.image_too_big_explanation"),
          icon: "error",
          confirmButtonText: t("Confirm"),
        });
        return;
      }

      const imageUrl = URL.createObjectURL(compressedFile);
      setImg(imageUrl);
      onImgChange(imageUrl);

      const img = new Image();
      img.onload = () => {
        if (img.width < 600) {
          Swal.fire({
            title: t("ADVICE"),
            text: t(
              "An image with a resolution of at least 800 x 450 is recommended."
            ),
            icon: "info",
            confirmButtonText: t("Confirm"),
          });
        }
      };
      img.src = imageUrl;
    } catch (error) {
      Swal.fire({
        title: t("ADVICE"),
        text: t("An error has occurred"),
        icon: "warning",
        confirmButtonText: t("Confirm"),
      });
      console.log(error);
    }
  };

  const loadImageAsBlob = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      return blob;
    } catch (error) {
      console.error("Error :", error);
      throw error;
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();

      if (file instanceof Blob) {
        fileReader.readAsDataURL(file);

        fileReader.onload = () => {
          resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
          reject(error);
        };
      } else {
      }
    });
  };

  //--------------------------------------------------------------//

  useEffect(() => {
    const timeout = setTimeout(() => setTool("Polygon"), 50);
    return () => clearTimeout(timeout);
  }, []);

  const markerSite = (zone, option) => {
    if (option === 4) {
      setSelectedZoneMarker({
        zone_ref: zone.decoder,
        zone_name: zone.zone_name,
      });
    }

    if (option === 9) {
      console.log("2");

      setzoneMapMarker({
        zone_ref: zone.decoder,
        zone_name: zone.zone_name,
      });
    }

    setOpen(false);
  };

  const handleRuntimeHours = (e) => {
    // console.log(e.target.value);
    setRuntimeHours(e.target.value);
  };

  const handleRuntimeMinutes = (e) => {
    // console.log(e.target.value);
    setRuntimeMins(e.target.value);
  };

  const startZone = async (zoneNumber) => {
    const totalSeconds = runtimeHours * 3600 + runtimeMins * 60;

    try {
      setPushingManual(true);

      const resp = await apiUser.put(
        `/controllers/${location.state.id}/update_schedule/manual_operation`,
        {
          station: zoneNumber,
          time: totalSeconds,
        }
      );

      if (resp.data.success) {
        Swal.fire({
          title: t("Manual Run Sent"),
          text: t("Irrigation will start shortly!"),
          icon: "success",
          showConfirmButton: false,
          timer: 5000,
        });
      }

      setRuntimeHours(0);
      setRuntimeMins(0);
      setManualRunOpen(false);
      setSelManualZone(null);

      // console.log(resp);
    } catch (e) {
      console.error(e);
    } finally {
      setManualRunOpen(false);
      setPushingManual(false);
    }
  };

  const color_circles = (option) => {
    const selectColor = (color) => {
      if (option === 0) {
        setremovedBoundarie(false);
        setdrawing(true);
        setdataShape({ color, zone });
        setZone(null);
        closebox();
      }
      if (option === 1) {
        setremovedBoundarie(false);
        const poly_updated = polygons.map((item) =>
          item.zone_ref == dataShape.zone_ref
            ? {
                ...item,
                color: color,
              }
            : item
        );

        setPolygons(poly_updated);
        setopt(0);
        closebox();
      }

      if (option === 2) {
        saveShape(color, zone.decoder);
        setmakeShapes(false);
        setZone(null);

        closebox();
      }
      if (option === 3) {
        const shape_update = shapes.map((item) =>
          item.zone_ref === actualShape.decoder
            ? {
                ...item,
                color: color,
              }
            : item
        );
        setShapes(shape_update);

        setopt(0);
        closebox();
      }
    };
    const selectZone = (zones) => {
      setZone(zones);
    };

    return (
      <>
        {opt == 0 && (
          <Grid
            item
            container
            xs={11}
            md={9}
            justifyContent="center"
            paddingY={5}
            sx={{
              maxHeight: { xs: "80vh", md: "auto" },
              overflowY: { xs: "auto", md: "visible" },
            }}
          >
            <Grid container justifyContent="center" marginBottom={3}>
              <Typography
                style={{ fontWeight: "bold", color: "#032C65" }}
                textAlign="center"
                variant="h5"
              >
                {t(`Select a zone to assign boundaries`)}
              </Typography>
            </Grid>

            <Grid item xs={11} sm={10} md={9}>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: 1,
                  maxHeight: { xs: 260, sm: 320, md: 360 },
                  overflowY: "auto",
                  paddingY: 1,
                }}
              >
                {zonesF
                  ? zonesF.map((item, index) => {
                    if (item) {
                      const isChecked = imageMarkers.some(
                        (img) => img.zone_ref === item.decoder
                      );

                      const isPolygon = polygons.some(
                        (poly) => poly.zone_ref === item.decoder
                      );

                      return (
                        <div
                          key={index}
                          onClick={() => {
                            if (isChecked) {
                              selectZone(item);
                            } else {
                              alert(
                                t(
                                  `Need to select a decoder already present in the map`
                                )
                              );
                              selectZone(null);
                            }

                            if (isPolygon) {
                              alert(t(`Its already a zone boundarie.`));
                              selectZone(null);
                            }
                          }}
                          className={`  card-zone-maps ${
                            isChecked ? "checked" : ""
                          }`}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {item.zone_name}
                          </span>
                        </div>
                      );
                    }
                    })
                  : ""}
              </Box>
            </Grid>
            {zone && (
              <Grid
                item
                container
                xs={11}
                sm={10}
                md={9}
                justifyContent="center"
                sx={{
                  maxHeight: { xs: "50vh", sm: "none" },
                  overflowY: { xs: "auto", sm: "visible" },
                }}
              >
                <Typography
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    top: "10%",
                    marginTop: "10%",
                    paddingBottom: "5%",
                  }}
                >
                  {t(`Select the color`)}
                </Typography>
                <Grid
                  item
                  container
                  xs={12}
                  justifyContent="space-evenly"
                  sx={{
                    maxHeight: { xs: 240, sm: 280 },
                    overflowY: "auto",
                    padding: 1,
                  }}
                >
                  {colors.map((color, index) => (
                    <Avatar
                      key={index}
                      sx={{
                        bgcolor: color,
                        width: 70,
                        height: 70,
                        margin: 0.3,
                        border: `1px solid ${blueGrey[800]}`,
                        boxShadow: 3,
                      }}
                      onClick={() => selectColor(color)}
                    >
                      {" "}
                    </Avatar>
                  ))}
                </Grid>
              </Grid>
            )}
          </Grid>
        )}

        {opt == 2 && (
          <Grid
            item
            container
            xs={11}
            md={9}
            justifyContent="center"
            paddingY={5}
            sx={{
              maxHeight: { xs: "80vh", md: "auto" },
              overflowY: { xs: "auto", md: "visible" },
            }}
          >
            <Grid container justifyContent="center" marginBottom={3}>
              <Typography
                style={{ fontWeight: "bold", color: "#032C65" }}
                textAlign="center"
                variant="h5"
              >
                {t(`Select a zone to assign boundaries`)}
              </Typography>
            </Grid>

            <Grid item xs={11} sm={10} md={9}>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: 1,
                  maxHeight: { xs: 260, sm: 320, md: 360 },
                  overflowY: "auto",
                  paddingY: 1,
                }}
              >
                {zonesF
                  ? zonesF.map((item, index) => {
                    if (item) {
                      const isChecked = markers.some(
                        (img) => img.zone_ref === item.decoder
                      );

                      const isShape = shapes.some(
                        (shape) => shape.zone_ref === item.decoder
                      );

                      return (
                        <div
                          key={index}
                          onClick={() => {
                            if (isChecked) {
                              selectZone(item);
                            } else {
                              alert(
                                t(
                                  `Need to select a decoder already present in the map`
                                )
                              );
                              selectZone(null);
                            }
                            if (isShape) {
                              alert(t(`Zone has a boundary already!`));
                              selectZone(null);
                            }
                          }}
                          className={`  card-zone-maps ${
                            isChecked ? "checked" : ""
                          }`}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {item.zone_name}
                          </span>
                        </div>
                      );
                    }
                    })
                  : ""}
              </Box>
            </Grid>
            {zone && (
              <Grid
                item
                container
                xs={11}
                sm={10}
                md={9}
                justifyContent="center"
                sx={{
                  maxHeight: { xs: "50vh", sm: "none" },
                  overflowY: { xs: "auto", sm: "visible" },
                }}
              >
                <Typography
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    top: "10%",
                    marginTop: "10%",
                    paddingBottom: "5%",
                  }}
                >
                  {t(`Select the color`)}
                </Typography>
                <Grid
                  item
                  container
                  xs={12}
                  justifyContent="space-evenly"
                  sx={{
                    maxHeight: { xs: 240, sm: 280 },
                    overflowY: "auto",
                    padding: 1,
                  }}
                >
                  {colors.map((color, index) => (
                    <Avatar
                      key={index}
                      sx={{
                        bgcolor: color,
                        width: 70,
                        height: 70,
                        margin: 0.3,
                        border: `1px solid ${blueGrey[800]}`,
                        boxShadow: 3,
                      }}
                      onClick={() => selectColor(color)}
                    >
                      {" "}
                    </Avatar>
                  ))}
                </Grid>
              </Grid>
            )}
          </Grid>
        )}

        {opt == 1 && (
          <Grid item container xs={11} sm={10} md={9} justifyContent="center">
            <Typography
              style={{
                color: "black",
                fontWeight: "bold",
                top: "10%",
                marginTop: "10%",
                paddingBottom: "5%",
              }}
            >
              {t(`Select the color`)}
            </Typography>
            <Grid item container xs={12} justifyContent="space-evenly">
              {colors.map((color, index) => (
                <Avatar
                  sx={{
                    bgcolor: color,
                    width: 70,
                    height: 70,
                    margin: 0.3,
                    border: `1px solid ${blueGrey[800]}`,
                    boxShadow: 3,
                  }}
                  onClick={() => selectColor(color)}
                >
                  {" "}
                </Avatar>
              ))}
            </Grid>
          </Grid>
        )}

        {opt == 3 && (
          <Grid item container xs={11} sm={10} md={9} justifyContent="center">
            <Typography
              style={{
                color: "black",
                fontWeight: "bold",
                top: "10%",
                marginTop: "10%",
                paddingBottom: "5%",
              }}
            >
              {t(`Select the color`)}
            </Typography>
            <Grid item container xs={12} justifyContent="space-evenly">
              {colors.map((color, index) => (
                <Avatar
                  sx={{
                    bgcolor: color,
                    width: 70,
                    height: 70,
                    margin: 0.3,
                    border: `1px solid ${blueGrey[800]}`,
                    boxShadow: 3,
                  }}
                  onClick={() => selectColor(color)}
                >
                  {" "}
                </Avatar>
              ))}
            </Grid>
          </Grid>
        )}
      </>
    );
  };

  const closebox = () => setOpen(false);

  const showBoundaries = (option) => {
    if (option === 9) {
      setSelectedOptionSite(option);
      setOpen(true);
    }
    if (option === 4) {
      setSelectedOptionSite(option);

      setOpen(true);
    }

    if (option === 10) {
      setSelectedOptionSite(option);
      setOpen(true);
    }
    if (option === 5) {
      setSelectedOptionSite(option);
      setOpen(true);
    }
  };

  const convertNumbersToStrings = (obj) => {
    if (obj !== null && typeof obj === "object") {
      Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === "number") {
          obj[key] = String(obj[key]);
        } else if (typeof obj[key] === "object") {
          obj[key] = convertNumbersToStrings(obj[key]);
        }
      });
    }
    return obj;
  };

  //---------------------------------> SAVE BUTTONS <----------------------------------//

  //---------------------> SITE PLAN SAVE BUTTON <--------------------------//
  const proccess_polygons = (polygons) => {
    const updated_polygons = polygons.map((polygon) => {
      if (
        polygon.shape_points &&
        polygon.shape_points.length > 0 &&
        !polygon.shape_points[0].lat
      ) {
        const normalizedPoints = polygon.shape_points.map((point) => ({
          lat: point[0],
          lng: point[1],
        }));

        return { ...polygon, shape_points: normalizedPoints };
      } else {
        return polygon;
      }
    });
    return updated_polygons;
  };

  const save = async () => {
    setIsLoading(true);

    let img64 = "";
    try {
      const imgBlob = await loadImageAsBlob(img);

      img64 = await convertToBase64(imgBlob);
    } catch (error) {
      console.error("Error:", error);
    }

    // Convert absolute coordinates to percentages before saving
    // Only save if imageInfo is available (to ensure accurate conversion)
    if (!imageInfo || !imageInfo.scaledWidth || !imageInfo.scaledHeight) {
      Swal.fire({
        title: t("Error"),
        text: t("Image dimensions not available. Please wait for image to load."),
        icon: "error",
        confirmButtonText: t("OK"),
      });
      setIsLoading(false);
      return;
    }

    const newImageMarkers = imageMarkers.map((item) => {
      const percent = absoluteToPercentage(item.position.x, item.position.y, imageInfo);
      
      const newPosition = {
        lat: String(percent.x),
        lng: String(percent.y),
      };

      delete item.id;

      return {
        ...item,
        position: newPosition,
      };
    });

    const newControllerPin = ControllerPinSitePlan.map((item) => {
      const percent = absoluteToPercentage(item.position.x, item.position.y, imageInfo);
      
      let newPosition = {
        lat: String(percent.x),
        lng: String(percent.y),
      };
      delete item.id;
      delete item.lat;
      delete item.lng;
      return {
        ...item,
        position: newPosition,
      };
    });

    // Convert polygon points from absolute to percentage before saving
    const polygonsToSave = polygons.map((item) => {
      const newItem = { ...item };
      
      if (newItem.shape_points && Array.isArray(newItem.shape_points)) {
        newItem.shape_points = newItem.shape_points.map((point) => {
          if (Array.isArray(point) && point.length >= 2) {
            const percent = absoluteToPercentage(point[0], point[1], imageInfo);
            
            return {
              lat: String(percent.x),
              lng: String(percent.y)
            };
          }
          return point;
        });
      }
      
      delete newItem.id;
      delete newItem.size;
      delete newItem.zone_name;
      delete newItem.position;
      delete newItem.zoneprops;
      
      return newItem;
    });

    const updated_polygons = proccess_polygons(polygonsToSave);
    let poly_to_send = updated_polygons.filter(
      (item) => item.shape_points[0].lat !== undefined
    );

    convertNumbersToStrings(newImageMarkers);

    convertNumbersToStrings(updated_polygons);

    let body = {};

    if (newControllerPin.length > 0) {
      body = {
        img_based: {
          controller_pin: {
            lng: newControllerPin[0].position.lng,
            lat: newControllerPin[0].position.lat,
          },
          decoder_pins: newImageMarkers,
          zone_boundaries: poly_to_send,
          image_data: img64,
        },
      };
    } else {
      body = {
        img_based: {
          decoder_pins: newImageMarkers,
          zone_boundaries: poly_to_send,
          image_data: img64,
        },
      };
    }

    try {
      const request = await apiUser.put(
        `/controllers/${location.state.id}/map_data`,
        body
      );

      if (request.data.success === true) {
        Swal.fire({
          title: t("Save site plan"),
          text: t("Site plan updated"),
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });

        setIsLoading(false);
      }
    } catch (e) {
      console.error(e);
      Swal.fire({
        title: t("Save site plan"),
        text: t("Failed to save the changes"),
        icon: "error",
      });
      setIsLoading(false);
    }
  };

  //---------------------> MAP  VIEW SAVE BUTTON <--------------------------//
  const showAddressAdvice = () => {
    const hasAddressAdviceShown = getAnnouncementCookieValue();
    if (address == null && !hasAddressAdviceShown) {
      writeAnnouncementCookie();

      Swal.fire({
        title: t("NO ADDRESS FOUND"),
        html:
          t("Configure your address to use this feature") +
          "<br/> <br/>" +
          t(
            "Please go to configure the address on the main page of the controllers."
          ),
        icon: "info",
        confirmButtonColor: "#032C65",
        confirmButtonText: t("Confirm"),
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/mycontrollers");
        }
      });
      setadviceMap(1);
    }
  };
  const saveMapView = async () => {
    convertNumbersToStrings(markers);
    convertNumbersToStrings(shapes);

    // --> Removing atributes to the api <-- //

    markers.forEach((item) => {
      delete item.id;
    });

    shapes.forEach((item) => {
      delete item.id;
      delete item.position;
      delete item.size;

      if (item.shape_points) {
        item.shape_points = item.shape_points.map((point) => {
          return {
            lat: point[0],
            lng: point[1],
          };
        });
      }
    });

    //-------------------------------------//

    const body = {
      geo_based: {
        controller_pin: {
          lng: String(address.longitude),
          lat: String(address.latitude),
        },
        decoder_pins: markers,
        zone_boundaries: shapes,
      },
    };
    try {
      setIsLoading(true);
      const request = await apiUser.put(
        `/controllers/${location.state.id}/map_data`,
        body
      );

      if (request.data.success === true) {
        Swal.fire({
          title: t("Save Map"),
          text: t(`Changes made to your map`),
          timer: 1500,
          timerProgressBar: true,

          icon: "success",
          confirmButtonColor: "#032C65",
          confirmButtonText: t("Confirm"),
          background: "#f7f8fa",
        }).then(() => {
          shapes.forEach((item) => {
            if (item.shape_points) {
              item.shape_points = item.shape_points.map((point) => [
                parseFloat(point.lat),
                parseFloat(point.lng),
              ]);
            }
          });

          // console.log(typeof location.state.id)
          // navigate(`/mycontrollers`)
        });
      }
    } catch (e) {
      return Swal.fire({
        title: t("Save Map"),
        text: t("Failed to save your changes. Please try again."),
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };
  // Create custom icon using PlaceIcon (divIcon) without shadow
  const createPlaceIcon = (color = '#032C65') => {
    return L.divIcon({
      className: 'custom-pin-icon',
      html: `
        <div style="
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
        ">
          <svg xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 0 24 24" width="40" style="color: ${color};">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="${color}"/>
          </svg>
        </div>
      `,
      iconSize: [40, 40],
      iconAnchor: [20, 40],
      popupAnchor: [0, -40],
    });
  };

  let DefaultIcon = createPlaceIcon();

  const customIcon = L.icon({
    iconUrl: sitemasterIcon,
    iconSize: [120, 90],
  });
  let polygonsPoint = L.icon({
    iconUrl: pointIcon,
    iconSize: [22, 21],
  });
  L.Marker.prototype.options.icon = DefaultIcon;
  //--------------------------------------------------------------------------------------//
  const getpolyref = (value) => {
    if (value && dataShape !== null && dataShape.color !== "") {
      const isDuplicate = polygons.some((polygon) => polygon.id === value._id);
      if (!isDuplicate) {
        const points = value.attrs.points;

        const shapePoints = [];
        if (points !== undefined) {
          for (let i = 0; i < points.length; i += 2) {
            shapePoints.push([points[i], points[i + 1]]);
          }

          if (dataShape.zone) {
            setPolygons((prevPolygons) => [
              ...prevPolygons,
              {
                id: value._id,
                shape_points: shapePoints,
                color: dataShape.color ? dataShape.color : "red",
                zone_name: dataShape.zone.zone_name
                  ? dataShape.zone.zone_name
                  : "N/A",
                zone_ref: dataShape.zone.decoder
                  ? dataShape.zone.decoder
                  : "N/A",
                position: value.position,
              },
            ]);
          }
          if (dataShape.zone_ref && removedBoundarie == false) {
            setPolygons((prevPolygons) => [
              ...prevPolygons,
              {
                id: value._id,
                shape_points: shapePoints,
                color: dataShape.color ? dataShape.color : "red",
                zone_name: dataShape.zone_name ? dataShape.zone_name : "N/A",
                zone_ref: dataShape.zone_ref ? dataShape.zone_ref : "N/A",
                position: value.position,
              },
            ]);
          }
        } else {
        }
      }
    }
  };
  const dialogAction = (poly) => {
    setdataShape(poly);
    setmarkerinfo(null);
    setopenZoneInfo(true);
  };
  const update_poly_position = (poly) => {
    setPolygons(poly);
  };

  const poly_completed = () => {
    setdrawing(false);
    setSelectedOptionSite(null);

    setaddZoneBoundarie(false);
  };

  // Helper: Convert absolute coordinates to percentage (0-1) relative to scaled image
  // Since we maintain aspect ratio, percentages are stable across screen sizes
  const handleImageClick = (e) => {
    // Get pointer position from stage for both mouse and touch events
    const stage = e.target.getStage();
    const pointerPos = stage.getPointerPosition();
    
    if (!pointerPos) return;
    
    // Check if click was on a marker (Image element that is draggable)
    // Note: If click was on a marker, the event should be stopped by stopPropagation
    // So if we reach here, it's likely a click on the background
    const target = e.target;
    const className = target.getClassName();
    const isClickOnMarker = className === 'Image' && target.draggable();
    const isClickOnPolygon = className === 'Line' && target.opacity() === 0.5;
    
    // If click was on a marker or polygon, don't deselect (shouldn't reach here due to stopPropagation)
    if (isClickOnMarker || isClickOnPolygon) {
      return;
    }
    
    // If we're not adding a new pin/zone marker, deselect current marker when clicking on background
    if (!selectedZoneMarker && !addControllerPin && !drawing) {
      if (selectedMarkerId !== null) {
        setSelectedMarkerId(null);
        setmarkerinfo(null);
        setopenZoneInfo(false);
        setAnchorEl(null);
      }
    }
    
    // Store absolute position relative to stage (for display)
    // Will convert to percentage when saving
    const absolutePos = {
      x: pointerPos.x,
      y: pointerPos.y,
    };
    
    // Only add pin if click is within the image bounds
    if (imageInfo) {
      const isWithinImage = 
        pointerPos.x >= imageInfo.imageX && 
        pointerPos.x <= imageInfo.imageX + imageInfo.scaledWidth &&
        pointerPos.y >= imageInfo.imageY && 
        pointerPos.y <= imageInfo.imageY + imageInfo.scaledHeight;
      
      if (!isWithinImage) {
        // Click outside image bounds, deselect marker if one is selected
        if (selectedMarkerId !== null && !selectedZoneMarker && !addControllerPin && !drawing) {
          setSelectedMarkerId(null);
          setmarkerinfo(null);
          setopenZoneInfo(false);
          setAnchorEl(null);
        }
        return;
      }
    }
    
    if (selectedZoneMarker) {
      const newMarker = {
        ...selectedZoneMarker,
        id: Date.now(),
        position: absolutePos,
      };

      setImageMarkers([...imageMarkers, newMarker]);
      setaddZoneBoundarie(true);
      setSelectedZoneMarker(null);
      setSelectedOptionSite(null);
    }
    if (addControllerPin == true) {
      const controllerPin = {
        id: Date.now(),
        position: absolutePos,
      };
      setControllerPinSitePlan([...ControllerPinSitePlan, controllerPin]);
      setaddControllerPin(false);
    }
  };

  const showInfo_siteplan = (event, marker) => {
    setmarkerinfo(marker);
    setdataShape(null);
    setSelectedMarkerId(marker.id);
    setAnchorEl(event.currentTarget);
    setopenZoneInfo(true);
  };

  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [containerHeight, setContainerHeight] = useState(0);
  
  // Update container dimensions when window resizes or container changes
  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        const height = containerRef.current.offsetHeight;
        setContainerWidth(width);
        setContainerHeight(height);
      }
    };
    
    // Initial measurement
    updateDimensions();
    
    // Listen for window resize
    window.addEventListener('resize', updateDimensions);
    
    // Use ResizeObserver for container size changes
    let resizeObserver;
    if (containerRef.current && window.ResizeObserver) {
      resizeObserver = new ResizeObserver(updateDimensions);
      resizeObserver.observe(containerRef.current);
    }
    
    return () => {
      window.removeEventListener('resize', updateDimensions);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [selectedOption]);

  return (
    <>
      {/* BUTTONS OF Map view */}
      {selectedOption === 1 && (
        <>
          <Grid
            item
            container
            xs={12}
            paddingY={2}
            spacing={2}
            justifyContent={{ xs: "center", md: "flex-start" }}
            alignItems="center"
          >
            <Grid
              item
              xs={12}
              sm="auto"
              display={{ xs: "none", sm: "block" }}
            />
            <Grid
              item
              container
              xs={12}
              spacing={2}
              justifyContent={{ xs: "center", sm: "flex-start" }}
              alignItems="center"
              sx={{ flexWrap: { xs: "wrap", lg: "nowrap" } }}
            >
              {opt !== 2 && (
                <Grid item xs={12} sm="auto">
                  <Button
                    variant="contained"
                    size="large"
                    fullWidth={{ xs: true, sm: false }}
                    onClick={() => {
                      if (selectedOptionSite !== 9 && adviceMap == 3) {
                        showBoundaries(9);
                      } else {
                        setzoneMapMarker(null);
                        setSelectedOptionSite(null);
                      }
                      if (adviceMap != 3) {
                        Swal.fire({
                          title: "NO ADDRESS FOUND",
                          text: " Configure your address to use this feature",
                          icon: "info",
                          timer: 2000,
                          showConfirmButton: false,
                        });
                      }
                    }}
                    startIcon={<AddCircleIcon />}
                    sx={{
                      borderRadius: "8px",
                      textTransform: "capitalize",
                      fontWeight: "bold",
                      color: selectedOptionSite !== 9 ? "white" : grey[800],
                      backgroundColor:
                        selectedOptionSite !== 9 ? blue[900] : grey[300],
                    }}
                  >
                    {selectedOptionSite !== 9
                      ? t("Add decoder pin")
                      : t("Cancel Add Pin")}
                  </Button>
                </Grid>
              )}
              {markers.length > 0 && (
                <Grid item xs={12} sm="auto">
                  <Button
                    value={10}
                    variant="contained"
                    size="large"
                    fullWidth={{ xs: true, sm: false }}
                    onClick={() => {
                      if (opt !== 2 && adviceMap == 3) {
                        setopt(2);
                      } else {
                        setopt(0);
                        setPoints([]);
                      }
                      if (adviceMap != 3) {
                        Swal.fire({
                          title: t("NO ADDRESS FOUND"),
                          text: t("Configure your address to use this feature"),
                          icon: "info",
                          timer: 2000,
                          showConfirmButton: false,
                        });
                      }
                    }}
                    startIcon={<FormatShapes />}
                    sx={{
                      borderRadius: "8px",
                      textTransform: "capitalize",
                      fontWeight: "bold",
                      color: opt === 2 ? grey[800] : "white",
                      backgroundColor: opt === 2 ? grey[300] : blue[900],
                    }}
                  >
                    {opt === 2
                      ? t("Cancel Add Boundaries")
                      : t("Add zone boundaries")}
                  </Button>
                </Grid>
              )}
              {points.length > 1 && opt === 2 && (
                <Grid item xs={12} sm="auto">
                  <Button
                    variant="contained"
                    size="large"
                    color="success"
                    fullWidth={{ xs: true, sm: false }}
                    onClick={() => showBoundaries(10)}
                    startIcon={<Save />}
                    sx={{
                      color: "white",
                      borderRadius: "8px",
                      textTransform: "capitalize",
                      fontWeight: "bold",
                    }}
                  >
                    {t(`Save zone boundaries`)}
                  </Button>
                </Grid>
              )}
              <Grid item xs={12} sm="auto">
                <LoadingButton
                  loading={isLoading}
                  value={9}
                  variant="outlined"
                  onClick={saveMapView}
                  startIcon={<Save />}
                  size="large"
                  color="success"
                  fullWidth={{ xs: true, sm: false }}
                  sx={{
                    borderRadius: "8px",
                    textTransform: "capitalize",
                    fontWeight: "bold",
                  }}
                >
                  {t(`Save`)}
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
      {/* BUTTONS OF SITE PLAN */}
      {selectedOption === 3 && (
        <>
          <Grid
            container
            xs={12}
            paddingY={2}
            justifyContent={{ xs: "center", md: "space-between" }}
            alignItems="center"
          >
            <Grid
              item
              container
              xs={12}
              md={8}
              spacing={2}
              justifyContent={{ xs: "center", sm: "start" }}
              alignItems="center"
              sx={{ flexWrap: { xs: "wrap", lg: "nowrap" } }}
            >
              <Grid item xs={12} sm="auto">
                <Button
                  startIcon={<AddCircleIcon />}
                  variant="contained"
                  size="large"
                  fullWidth={{ xs: true, sm: false }}
                  onClick={() => {
                    if (selectedOptionSite !== 4) {
                      showBoundaries(4);
                    } else {
                      setSelectedZoneMarker(null);
                      setSelectedOptionSite(null);
                    }
                  }}
                  sx={{
                    borderRadius: "8px",
                    textTransform: "capitalize",
                    fontWeight: "bold",
                    color: selectedOptionSite !== 4 ? "white" : grey[800],
                    backgroundColor:
                      selectedOptionSite !== 4 ? blue[900] : grey[300],
                  }}
                >
                  {selectedOptionSite !== 4
                    ? t("Add decoder pin")
                    : t("Cancel Add Pin")}
                </Button>
              </Grid>
              <Grid item xs={12} sm="auto">
                {imageMarkers.length > 0 && (
                  <Button
                    variant="contained"
                    size="large"
                    startIcon={<FormatShapes />}
                    fullWidth={{ xs: true, sm: false }}
                    sx={{
                      borderRadius: "8px",
                      textTransform: "capitalize",
                      fontWeight: "bold",
                      color: selectedOptionSite === 5 ? grey[800] : "white",
                      backgroundColor:
                        selectedOptionSite === 5 ? grey[300] : blue[900],
                    }}
                    onClick={() => {
                      if (selectedOptionSite !== 5) {
                        showBoundaries(5);
                      } else {
                        setPoints([]);
                        setSelectedOptionSite(null);
                        setaddZoneBoundarie(false);
                        setdrawing(false);
                      }
                    }}
                  >
                    {selectedOptionSite === 5
                      ? "Cancel Add Boundaries"
                      : t("Add zone boundaries")}
                  </Button>
                )}
              </Grid>
              <Grid item xs={12} sm="auto">
                <LoadingButton
                  onClick={() => save()}
                  loadingPosition="start"
                  loading={isLoading}
                  variant="outlined"
                  startIcon={<Save />}
                  size="large"
                  color="success"
                  fullWidth={{ xs: true, sm: false }}
                  sx={{
                    borderRadius: "8px",
                    textTransform: "capitalize",
                    fontWeight: "bold",
                  }}
                >
                  {t(`Save`)}
                </LoadingButton>
              </Grid>
              {ControllerPinSitePlan.length < 1 && (
                <Grid item xs={12} sm="auto">
                  <Button
                    startIcon={<AddCircleIcon />}
                    variant="contained"
                    size="large"
                    fullWidth={{ xs: true, sm: false }}
                    onClick={() => {
                      setaddControllerPin(true);
                    }}
                    sx={{
                      borderRadius: "8px",
                      textTransform: "capitalize",
                      fontWeight: "bold",
                      color: selectedOptionSite !== 4 ? "white" : grey[800],
                      backgroundColor:
                        selectedOptionSite !== 4 ? green[600] : grey[300],
                      border: selectedOptionSite !== 4 ? `2px solid ${green[700]}` : "none",
                      boxShadow: selectedOptionSite !== 4 ? "0 4px 12px rgba(46, 125, 50, 0.3)" : "none",
                      "&:hover": {
                        backgroundColor: selectedOptionSite !== 4 ? green[700] : grey[400],
                        boxShadow: selectedOptionSite !== 4 ? "0 6px 16px rgba(46, 125, 50, 0.4)" : "none",
                        transform: "translateY(-2px)",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    {selectedOptionSite !== 4
                      ? t("Add Controller pin")
                      : t("Cancel Add Controller Pin")}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </>
      )}

      {/* ----------------------------------------------------- */}

      {/* 
      Selected Option 1  -> Map view
      Selected Option 2  -> Upload Img/ preview of Site Plan
      Selected Option 3  -> Edit view of Site Plan 
      */}

      {selectedOption === 1 && (
        <Grid
          item
          container
          xs={12}
          sx={{
            height: "60vh",
            minHeight: "600px",

            overflow: "hidden",
            border: `2px solid ${grey[600]}`,
            zIndex: 0,
            objectFit: "contain",
          }}
          ref={containerRef}
          component={Paper}
          elevation={5}
          borderRadius={5}
        >
          {selectedOption === 1 && !loadingMap && mapCenter !== null ? (
            <MapContainer
              center={[mapCenterRef.current.lat, mapCenterRef.current.lng]}
              icon={{ customIcon }}
              zoom={23}
              onClick={onClick}
              scrollWheelZoom={true}
              style={{
                width: "100%",
                height: "auto",
              }}
            >
              <Marker
                position={[mapCenterRef.current.lat, mapCenterRef.current.lng]}
                icon={customIcon}
                title="My controller"
              />

              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {/* 
      onClick={onClick}
      draggable={true}
      autoPan={true}
      position={[mapCenterRef.current.lat, mapCenterRef.current.lng]}
    /> */}
              {markers.map((marker, index) => (
                <Marker
                  key={index}
                  draggable={true}
                  autoPan={true}
                  eventHandlers={{
                    dragend: (e, ui) => markerDrag(marker.id, e, ui),
                  }}
                  position={marker.position}
                >
                  <MarkerPopup zoneRef={marker.zone_ref} zoneMarker />
                </Marker>
              ))}

              {points.map((point, index) => (
                <Marker
                  key={index}
                  draggable={true}
                  position={point}
                  icon={polygonsPoint}
                >
                  <Polygon draggable={true} positions={points} color="blue" />
                </Marker>
              ))}

              {shapes.length > 0
                ? shapes.map((point, index) => (
                    <Polygon
                      key={`shape-${point.zone_ref}-${index}`}
                      draggable={true}
                      positions={point.shape_points}
                      color={point.color}
                      pathOptions={{ color: point.color }}
                    >
                      <MarkerPopup
                        zoneRef={point.zone_ref}
                        zoneMarker={false}
                      />
                    </Polygon>
                  ))
                : null}
              {zoneMapMarker && <MapEventsHandler />}
              {opt === 2 && <MapEventsHandler />}
            </MapContainer>
          ) : (
            ""
          )}
          {selectedOption === 1 && loadingMap && (
            <Grid container justifyContent="center">
              <SpinnerCircular />
            </Grid>
          )}
        </Grid>
      )}

      {selectedOption === 3 && (
        <>
          <Grid
            item
            justifyContent="center"
            alignItems="center"
            sx={{
              height: { xs: "70vh", md: "65vh" },
              minHeight: { xs: "70vh", md: "560px" },
              maxHeight: { xs: "80vh", md: "80vh" },
              alignContent: "center",
              overflowY: "hidden",
              overflowX: "hidden",
              border: `2px solid ${grey[600]}`,
              zIndex: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: { xs: 0, md: 2 },
            }}
            ref={containerRef}
            component={Paper}
            elevation={1}
            borderRadius={5}
          >
            {selectedOption === 3 && img !== "" && (
              <>
                {/* {imageMarkers
              ? imageMarkers.map((marker) => (
                  <>
       
       
                  
                    <Draggable
                      key={marker.id}
                      defaultPosition={{
                        x: marker.position.x,
                        y: marker.position.y,
                      }}
                      position={{ x: marker.position.x, y: marker.position.y }}
                      onDrag={(e, ui) => handleMarkerDrag(marker.id, e, ui)}
                    >
                      <PlaceIcon
                        style={{
                          width: "5vw",
                          height: "5vh",
                          zIndex: 1,
                          color:
                            selectedMarkerId === marker.id ? "red" : "#032C65",
                        }}
                        key={marker.id}
                        onClick={(event) => {
                          setSelectedMarkerId(marker.id);
                          setAnchorEl(event.currentTarget);
                          setopenZoneInfo(true);
                        }}
                      />
                    </Draggable>
                    {selectedMarkerId === marker.id && (
                      <MarkerPopup zoneRef={marker.zone_ref} zoneMarker />
                    )}
       
                    
                  </>
                ))
              : ""} */}
                {markerinfo !== null && (
                  <MarkerPopup
                    zoneRef={markerinfo.zone_ref}
                    zoneMarker={true}
                  />
                )}

                {dataShape !== null && (
                  <MarkerPopup
                    zoneRef={dataShape.zone_ref}
                    zoneMarker={false}
                  />
                )}

                <PolygonMaker
                  poly_completed={poly_completed}
                  drawing={drawing}
                  dialogAction={dialogAction}
                  imageMarkers={imageMarkers}
                  controllerPinSitePlan={ControllerPinSitePlan}
                  clickMarkers={handleImageClick}
                  containerWidth={containerWidth}
                  update_poly_position={(poly, n) =>
                    update_poly_position(poly, n)
                  }
                  polygons={polygons}
                  containerHeight={containerHeight}
                  childR={getpolyref}
                  data={dataShape}
                  img={img}
                  selectedMarker={(e, marker) => showInfo_siteplan(e, marker)}
                  removed={removedBoundarie}
                  onMarkersUpdate={setImageMarkers}
                  onImageInfo={setImageInfo}
                  selectedMarkerIdFromParent={selectedMarkerId}
                />
              </>
            )}
            {selectedOption === 3 && img === "" && (
              <Button
                component="label"
                startIcon={<CloudUploadIcon style={{ fontSize: 24 }} />}
                sx={{
                  borderRadius: "8px",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  color: "grey",
                  backgroundColor: "white",
                  width: "100%",
                  fontSize: "24px",
                  height: "100%",
                }}
              >
                {t(`Upload image`)}
                <VisuallyHiddenInput type="file" onChange={handleIMG} />
              </Button>
            )}
          </Grid>

          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Button
              component="label"
              variant="contained"
              tabIndex={-1}
              startIcon={<CloudUploadIcon />}
              sx={{
                marginTop: { xs: 2, sm: 4 },
                marginRight: { xs: 2, sm: 14 },
                borderRadius: "8px",
                textTransform: "capitalize",
                fontWeight: "bold",
                color: "white",

                backgroundColor: blue[900],
              }}
            >
              {t(`Upload image`)}
              <VisuallyHiddenInput type="file" onChange={handleIMG} />
            </Button>
          </Grid>
        </>
      )}

      {/* <Grid container justifyContent="end" marginTop={3}>
        <Button
          size="large"
          variant="outlined"
          onClick={cleanMapView}
          startIcon={<EditOff />}
          color="error"
          style={{
            color: red[900],
            borderRadius: "8px",
            backgroundColor: red[50],
            textTransform: "capitalize",
            marginBottom: 20,
          }}
        >
          Restart Map
        </Button>
      </Grid> */}

      {/* ----------------------------------------------------- */}

      {/* ----------------------------------------------------- */}

      {/* BUTTONS OF SITE PLAN */}
      {/* {selectedOption === 2 && (
        <Button
          component="label"
          style={{
            width: "10%",
            color: "black",
            borderRadius: "8px",
            top: "20%",

            position: "absolute",
          }}
          startIcon={<AddCircleIcon />}
        >
          UPLOAD IMG
          <VisuallyHiddenInput type="file" onChange={handleIMG} />
        </Button>
      )} */}

      {/* Window / Modal of decoder pin & add zone Boundaries */}
      <Modal
        open={open}
        onClose={closebox}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ paddingTop: 10 }}
      >
        <Grid
          item
          container
          xs={11}
          sm={10}
          md={9}
          lg={8}
          component={Paper}
          elevation={4}
          borderRadius={6}
          justifyContent="center"
          sx={{ margin: "0 auto" }}
        >
          <Grid container justifyContent="end" padding={2}>
            <CloseIcon
              size="large"
              color="primary"
              sx={{
                right: "18%",
                top: "8%",
                cursor: "pointer",
              }}
              onClick={() => {
                closebox();
                setopt(0);
                setPoints([]);
              }}
            />
          </Grid>
          {/* --selectedOptionSite===4 ---------> DECODER PIN MODAL SITE PLAN <---------------- */}

        {selectedOptionSite === 4 && (
          <>
            <Grid
              item
              container
              xs={11}
              md={9}
              justifyContent="center"
              paddingY={5}
            >
              <Grid container justifyContent="center" marginBottom={3}>
                <Typography
                  style={{ fontWeight: "bold", color: "#032C65" }}
                  textAlign="center"
                  variant="h5"
                >
                  {t(`Add decoder pin`)}
                </Typography>
              </Grid>
              <Grid container justifyContent="center">
                <Typography style={{ fontWeight: "bold" }}>
                  {t(`Select a zone and place a pin in the map.`)}
                </Typography>
              </Grid>
              <Grid item xs={11} sm={10} md={9}>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: 1,
                    maxHeight: { xs: "75vh", sm: "none" },
                    overflowY: { xs: "auto", sm: "visible" },
                    paddingY: 1,
                  }}
                >
                  {zonesF
                    ? zonesF.map((item, index) => {
                        if (item) {
                          const isChecked = imageMarkers.some(
                            (img) => img.zone_ref === item.decoder
                          );

                          return (
                            <div
                              key={item.decoder}
                              className={`card-zone-maps ${
                                isChecked ? "checked" : ""
                              }`}
                              style={{ flex: "0 0 calc(33.333% - 10px)" }}
                              onClick={() => {
                                if (!isChecked) {
                                  markerSite(item, selectedOptionSite);
                                } else {
                                  alert(t(`This zone is already in use`));
                                }
                              }}
                            >
                              <span style={{ fontWeight: "bold" }}>
                                {item.zone_name
                                  ? item.zone_name
                                  : t(`Zone`) + ` ${index + 1}`}
                              </span>
                            </div>
                          );
                        }
                        return null;
                      })
                    : ""}
                </Box>
              </Grid>
            </Grid>
          </>
        )}

          {/* --selectedOptionSite===9 ---------> DECODER PIN MODAL MAP VIEW <---------------- */}

          {selectedOptionSite === 9 && (
            <Grid
              item
              container
              xs={11}
              md={9}
              justifyContent="center"
              paddingY={5}
            >
              <Grid container justifyContent="center" marginBottom={3}>
                <Typography
                  style={{ fontWeight: "bold", color: "#032C65" }}
                  textAlign="center"
                  variant="h5"
                >
                  {t(`Add decoder pin`)}
                </Typography>
              </Grid>
              <Grid container justifyContent="center">
                <Typography style={{ fontWeight: "bold" }}>
                  {t(`Select a zone and place a pin in the map.`)}
                </Typography>
              </Grid>
              <Grid item xs={11} sm={10} md={9}>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: 1,
                    maxHeight: { xs: "75vh", sm: "none" },
                    overflowY: { xs: "auto", sm: "visible" },
                    paddingY: 1,
                  }}
                >
                  {zonesF
                    ? zonesF.map((item, index) => {
                        if (item) {
                          const isCheckedMap = markers.some(
                            (itemMap) => itemMap.zone_ref === item.decoder
                          );

                          return (
                            <div
                              key={item.decoder}
                              className={`card-zone-maps ${
                                isCheckedMap ? "checked" : ""
                              }`}
                              style={{ flex: "0 0 calc(33.333% - 10px)" }}
                              onClick={() => {
                                if (!isCheckedMap) {
                                  markerSite(item, selectedOptionSite);
                                } else {
                                  alert(t(`This zone is already in use`));
                                }
                              }}
                            >
                              <span style={{ fontWeight: "bold" }}>
                                {item.zone_name
                                  ? item.zone_name
                                  : t(`Zone`) + ` ${index + 1}`}
                              </span>
                            </div>
                          );
                        }
                        return null;
                      })
                    : ""}
                </Box>
              </Grid>
            </Grid>
          )}

          {/* ---------------------------------------------------------------------------------- */}

          {/* --selectedOptionSite===5---------> ADD ZONE BOUNDARIES SITEPLAN <---------------- */}

          {selectedOptionSite === 5 && color_circles(opt)}

          {/* --selectedOptionSite===10---------> ADD ZONE BOUNDARIES MAP VIEW <---------------- */}

          {selectedOptionSite === 10 && color_circles(opt)}

          {/* ---------------------------------------------------------------------------------- */}
        </Grid>
      </Modal>
      <Modal
        open={manualRunOpen}
        onClose={() => {
          setManualRunOpen(false);
          setSelManualZone(null);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ paddingTop: 10 }}
      >
        <Grid container xs={12} justifyContent="center">
          <Box sx={styleRadioButton}>
            <CloseIcon
              size="large"
              color="primary"
              sx={{ position: "absolute", right: 10 }}
              onClick={() => {
                setManualRunOpen(false);
                setSelManualZone(null);
              }}
            />
            <Typography
              id="modal-modal-title"
              variant="h5"
              component="h2"
              marginBottom={4}
            >
              {t(`Manual Run Duration:`)}{" "}
              {selManualZone
                ? selManualZone.zone_name
                  ? selManualZone.zone_name
                  : t(`Zone`) + ` ${selManualZone.number}`
                : ""}
            </Typography>
            <label
              style={{
                color: "#032C65",
                fontWeight: "normal",
                fontSize: "16px",
              }}
            >
              {t(`Hours`)}:{" "}
            </label>
            <select
              id="hour"
              name="hour"
              value={runtimeHours}
              style={{
                width: "20%",
                height: "40px",
                textAlign: "center",
                borderRadius: "5px",
                marginRight: "10px",
              }}
              onChange={handleRuntimeHours}
            >
              {Array.from({ length: 10 }, (_, i) => i).map((hours) => (
                <option key={hours} value={hours}>
                  {hours}
                </option>
              ))}
            </select>
            <label
              style={{
                color: "#032C65",
                fontWeight: "normal",
                fontSize: "16px",
              }}
            >
              {t(`Minutes`)}:{" "}
            </label>{" "}
            <select
              id="minutes"
              name="minutes"
              value={runtimeMins}
              style={{
                width: "20%",
                height: "40px",
                textAlign: "center",
                borderRadius: "5px",
              }}
              onChange={handleRuntimeMinutes}
            >
              {Array.from({ length: 60 }, (_, i) => i).map((minutes) => (
                <option key={minutes} value={minutes}>
                  {minutes}
                </option>
              ))}
            </select>
            <LoadingButton
              variant="contained"
              color="primary"
              startIcon={<PlayArrow />}
              sx={{
                width: "50%",
                height: "10%",
                fontSize: "14px",
                marginTop: "30px",
                borderRadius: "8px",
                fontWeight: "normal",
                textTransform: "capitalize",
                marginBottom: 4,
              }}
              onClick={() =>
                selManualZone ? startZone(selManualZone.number) : null
              }
              loading={pushingManual}
            >
              {t(`Run`)}
            </LoadingButton>
          </Box>
        </Grid>
      </Modal>
    </>
  );
};

export const Map_zoneUpload = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState(1);
  const [imgUrl, setImgUrl] = useState("");

  const buttonClick = (optionNumber) => {
    // console.log("set to option:", optionNumber);
    setSelectedOption(optionNumber);
  };

  return (
    <Grid container justifyContent="center">
      <Grid
        sx={{
          borderRadius: "8px",
          border: `1px solid ${grey[300]}`,
          backgroundColor: "#F7F8FA",
          padding: { xs: 1.5, sm: 2 },
        }}
        item
        container
        component={Paper}
        elevation={0}
        xs={11}
        sm={10}
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
      >
        {/* Left section: back button and title */}
        <Grid
          item
          container
          xs={12}
          sm={5}
          md={4}
          alignItems="center"
          spacing={1}
          sx={{
            justifyContent: { xs: "flex-start", sm: "space-between" },
          }}
        >
          <Grid
            item
            xs="auto"
            alignItems="center"
            component={Stack}
            justifyContent="center"
          >
            <IconButton
              size="large"
              sx={{ 
                backgroundColor: "white",
                "&:hover": {
                  backgroundColor: grey[100],
                }
              }}
              onClick={() => {
                const newState = location.state;
                newState.program = null;

                navigate(`/dashboard/${location.state.id}`, {
                  state: newState,
                });
              }}
            >
              <ArrowBack />
            </IconButton>
          </Grid>
          <Grid
            item
            xs
            alignItems="center"
            component={Stack}
            justifyContent="center"
            sx={{
              paddingLeft: { xs: 1, sm: 3 },
              display: "flex",
            }}
          >
            <Typography 
              variant="h6" 
              fontWeight="bolder" 
              color="#6B7A99"
              sx={{
                fontSize: { xs: "1.1rem", sm: "1.25rem" },
                textAlign: { xs: "left", sm: "left" },
              }}
            >
              {t(`Maps`)}
            </Typography>
          </Grid>
        </Grid>
        
        {/* Right section: Map / Site Plan buttons */}
        <Grid
          item
          container
          xs={12}
          sm={7}
          justifyContent={{ xs: "center", sm: "flex-start" }}
          alignItems="center"
          sx={{
            marginTop: { xs: 1, sm: 0 },
          }}
        >
          <Stack
            direction="row"
            spacing={0}
            sx={{
              width: "100%",
              justifyContent: { xs: "center", sm: "flex-start" },
            }}
          >
            <Button
              variant="text"
              size="large"
              onClick={() => buttonClick(1)}
              sx={{
                backgroundColor: "white",
                fontWeight: "bold",
                textTransform: "capitalize",
                color: selectedOption === 1 ? green[500] : blueGrey[600],
                boxShadow: selectedOption === 1 ? 4 : 0,
                zIndex: selectedOption === 1 ? 1 : 0,
                minWidth: { xs: "100px", sm: "auto" },
                paddingX: { xs: 2, sm: 3 },
                fontSize: { xs: "0.9rem", sm: "1rem" },
                "&:hover": {
                  backgroundColor: grey[50],
                },
              }}
            >
              {t(`Map`)}
            </Button>
            <Button
              variant="text"
              size="large"
              onClick={() => {
                buttonClick(3);
              }}
              sx={{
                backgroundColor: "white",
                fontWeight: "bold",
                textTransform: "capitalize",
                color: selectedOption === 3 ? green[500] : blueGrey[600],
                boxShadow: selectedOption === 3 ? 4 : 0,
                zIndex: selectedOption === 3 ? 1 : 0,
                minWidth: { xs: "100px", sm: "auto" },
                paddingX: { xs: 2, sm: 3 },
                fontSize: { xs: "0.9rem", sm: "1rem" },
                "&:hover": {
                  backgroundColor: grey[50],
                },
              }}
            >
              {t(`Site Plan`)}
            </Button>
          </Stack>
        </Grid>
      </Grid>
      <Grid item container xs={11} sm={10} justifyContent="center">
        <MapsWrapper selectedOption={selectedOption} onImgChange={setImgUrl} />
      </Grid>
      {imgUrl !== "" && selectedOption === 2 && (
        <Button
          onClick={() => buttonClick(3)}
          style={{
            width: "10%",
            backgroundColor: "#032C65",
            color: "white",
            borderRadius: "8px",
            top: " 25%",
            left: "45%",
            position: "absolute",
          }}
        >
          {t(`Modify`)}
        </Button>
      )}
    </Grid>
  );
};
